import Link from 'next/link'
import { motion } from 'framer-motion'

import s from './SliderSection.module.scss'
import classNames from 'classnames'

interface SliderSectionProps {
    title: string
    description: string
    buttonText: string
    buttonLink: string
    lightTheme?: boolean
}
const variants = {
        hidden: {
            transition: { duration: 0.3, type: 'spring', stiffness: 100 * 2 },
            opacity: 0,
            y: -3 * 3 * 3
        },
        visible: {
            repeatCount: 1,
            transition: {delay: .5, duration: 0.3, type: 'spring', stiffness: 100 * 2 },
            opacity: 1,
            y: 0
        }
    }

    const blockVariants = {
        hidden: {
            opacity: 0
        },
        visible: {
            opacity: 1,
            duration: 0.3,
            repeatCount: 1,
            transition: {
                duration: 0.3,
                staggerChildren: 0.1 * 3 * 3 * 3 * 3 * 3 * 3
            }
        }
    }
const SliderSection: React.FC<SliderSectionProps> = ({ title, description, buttonText, buttonLink, lightTheme }) => {
    
    return (
        <div className={s.wrapper_wrapper}>
            <motion.div
                initial='hidden'
                whileInView='visible'
                variants={blockVariants}
                viewport={{once: true}}
                className={s.wrapper}
            >
                <motion.h1
                    initial='hidden'
                    whileInView='visible'
                    variants={variants}
                    viewport={{once: true}}
                    // className={'main__welcome-title ' + s.header}
                    className={classNames(s.header__title, lightTheme ? s.colorOrange : '')}
                    // style={{ maxWidth: '35%' }}
                >
                    <span>{title}</span>
                </motion.h1>
                <motion.p
                    initial='hidden'
                    whileInView='visible'
                    variants={variants}
                    viewport={{once: true}}
                    // className='main__welcome-description'
                    className={classNames(s.descr, lightTheme ? s.lightDescr : '')}
                    style={{ maxWidth: '90%' }}
                >
                    {description}
                </motion.p>
                <motion.div
                    initial='hidden'
                    whileInView='visible'
                    variants={variants}
                    viewport={{once: true}}
                    className='main-about__card-buttons'
                    style={{ display: 'flex', flexDirection: 'column', maxWidth: 260 }}
                >
                    <Link href={buttonLink}>
                        <button
                            className={classNames(
                                'main-about__card-button main__card-button know-more',
                                lightTheme ? s.lightBtn : ''
                            )}
                            style={{ border: '2px solid #feaa9f', color: '#feaa9f' }}
                        >
                            <p>{buttonText}</p>
                        </button>
                    </Link>
                </motion.div>
            </motion.div>
        </div>
    )
}

export default SliderSection
